// IE 2026 09 30 / ODOO-343436: строка итога (row_type 'Total', totals:'start'|'end' у Rows-узла REPORT2) не участвует в поиске по чипсам и не является «пустой» —
// при включённом фильтре непустых (_hide_empty) она всегда видна. Чистая предикатная логика, без Vue и DOM. Тест: tests/unit/gridTotalRow.test.mjs
export function gridTotalRow_is(dataItem) {
    return dataItem?._DLRow?.row_type === 'Total' || dataItem?._variant === 'Total'
}
